<template>
   <YLayoutBodyMenu :menu="[
       {title:'基础配置',path:'/shop/plugin/franchise-store/conf'},
       {title:'用户列表',path:'/shop/plugin/franchise-store/manage'},
       {title:'资金池',path:'/shop/plugin/franchise-store/pool'},
   ]">
     <router-view/>
   </YLayoutBodyMenu>
</template>

<script>
import YLayoutBodyMenu from "@/components/layouts/YLayoutBodyMenu";
export default {
  name: "index",
  components: {YLayoutBodyMenu},
}
</script>

<style scoped>

</style>